import axios from "axios";

const API_NEW = process.env.REACT_APP_API_NEW;
const API_OLD = process.env.REACT_APP_API_OLD;

// user state
export const vUserState = {
    check_all: -1, // 全選
    abnormal_pick_again: 1, //重新檢驗中
    abnormal_detect_again: 2, //晶片重新檢驗
    abnormal_other: 3, // 異常
    analysis: 4, // 分析中
    unsigned_center: 5, // 待中心簽名
    unsigned_doctor: 6, // 待醫生簽名
    unsigned_both: 7, // 待簽名
    detect: 8, // 檢驗中
    not_download: 9, // 待下載
    already_download: 10, // 已下載
    disagree_doctor: 11, // 醫生不同意
    disagree_center: 12, // 中心不同意
    disagree_both: 13, // 不同意
    pdf_create: 14, // PDF處理中
    sign_finish: 15, // 已完成簽名
    report_finish: 16, // 報告完成
    message_send: 17, // 報告已簡訊發送
    questionnaire_finish: 18, // 問卷報告完成
    vcf_ready: 20, // VCF 已就緒
    abnormal_system: 99, //
};

// org_type
// export const vOrgType: { [x: string]: number } = {
//     dealer: 1, // 經銷商
//     examine: 2, // 中心
//     medical: 3, // 審核報告醫生 中附醫
//     efai: 5, // 長佳內部人員
//     inspection: 6, // 檢驗部
//     doctor: 7, // 特約諮詢醫生
// };

// system_type
export enum vSystemType {
    blank = 0,
    genebox = 1, //基因寶
    gutflora = 2, //腸菌寶
    nips = 3, //NIPS
}

export enum ListType {
    sign_list = "sign_list",
    report_list = "report_list",
}

export enum DataType {
    checkDate = 1,
    downloadDate = 2,
}

// org_id
// export interface vOrgIdInfo {
//     org_type: number;
//     org_id: number;
//     org_code: string;
//     name: string;
// }

// export interface vOrgIdType {
//     [x: string]: vOrgIdInfo;
// }

export interface Authority_System {
    Access: boolean;
    upload: boolean;
    download: boolean;
    report_exception: boolean;
    doctor_sign: boolean;
    pmc_sign: boolean;
    vendor: {
        VT: Authority_dealer;
        EH: Authority_dealer;
        TM: Authority_dealer;
        ES: Authority_dealer;
        [key: string]: Authority_dealer;
    };
}

export interface Authority_dealer {
    worklist: boolean;
    appointed: boolean;
}

interface Authority_Fun {
    export_worklist: boolean;
    agent_limit: string;
    make_downloaded: boolean;
    enable_comment: boolean;
    excel_upload_specimen: boolean;
}

export interface role {
    projects: {
        genebox: Authority_System;
        gutflora: Authority_System;
        nips: Authority_System;
        [key: string]: Authority_System;
    };

    Functions: Authority_Fun;
    [key: string]: any;
}

export interface vTokenData {
    display_name: string;
    exp: number;
    iss: string;
    user_id: string;
}

// export const blankOrgId: vOrgIdType = {
//     blank: {
//         org_type: -1,
//         org_id: -1,
//         name: "",
//         org_code: "",
//     },
// };
export interface vLogoutOutput {
    respCode: number;
    respDesc: string;
}

export interface ResponseCode extends vLogoutOutput {
    token: string;
}

// export interface signedurlOutput extends ResponseCode {
//     url: string;
//     blobname: string;
// }

interface Response {
    error_code: number;
    error_desc: string;
}

export interface LoginInput {
    acc: string;
    pwd: string;
}

interface LoginOutput extends Response {
    data: {
        token: string;
        is_admin: boolean;
        role_data: role;
    };
}

export interface ResetPasswordInput {
    current_password: string;
    new_password: string;
    [key: string]: any;
}

interface SuccessedOutput extends Response {
    data: null;
}

export interface getUserListOutput extends vSignListOutput {
    uid: string;
    uname: string;
    org_id: number;
    org_name: string;
    gender: string;
    date: string;
    state: number;
    abnormal_des: string;
    center_comment: string;
    doctor_comment: string;
    error_message: string;
    sign_time: string;
    zip_upload_time: string;
    latest_pdf_time: string;
    latest_gf_time: string;
    mod_generation_status: pdfMode[];
    [x: string]: any;
}
export interface pdfMode {
    name: string;
    id: string;
    status: boolean;
    timestamp?: string;
    version?: number;
}
export interface UserPdfMode {
    uid: string;
    mod_list: pdfMode[];
}

export interface PostPdfMode {
    uid: string;
    mod_list: string[];
    report_version?: number;
}

export interface AllPdf {
    id: string;
    name: string;
}

// export interface getAllPDF extends ResponseCode {
//     respDesc: string;
//     respCode: number;
//     default: AllPdf[];
// }
// export interface checkZipCrc32Output extends ResponseCode {
//     data_count: number;
//     error_list: string[];
// }

export interface ReportListOutput {
    file_name: string;
    date: string;
}

export interface vSignListOutput {
    uid: string;
    uname: string;
    gender: string;
    date: string;
    high_risk_count: number;
    medium_risk_count: number;
    physique_count: number;
    state: number;
    report_version: string;
    [x: string]: any;
}

export interface vUploadFile extends ResponseCode {
    data_count: number;
    error_list: string[];
    respDesc: string;
    respCode: number;
}

//User comment
export interface IUserCommentInput {
    uid: string;
    abnormal?: boolean;
    comment: string;
    report_version?: string;
}

//個基因列表
export interface gene_list {
    gene_name: string;
    gene_explain: string;
    high: string;
    general: string;
    low: string;
    risk: number;
    risk_class: number;
}

//氣喘、肺腺癌
export interface risk_list {
    item: string;
    relation: number;
    risk_class: number;
    risk_legend: string;
    risk_value: string;
    gene_list: gene_list[];
    clinvar_table: clinvar_list;
    [x: string]: any;
}

export interface clinvar_list {
    item_list: clinvar_list_item[];
}

export interface clinvar_list_item {
    gene_info: clinvar_item;
}
export interface clinvar_item {
    name: string;
    clinvar_class: string;
    explain: string;
    high: number;
    mid: number;
    total: number;
    [x: string]: any;
}
//
export interface vUserReportListOutput extends ResponseCode {
    uid: string;
    gender: string;
    date: string;
    item_list: risk_list[];
    [x: string]: any;
}

export interface EditInput {
    uid: string;
    uname: string;
    gender: string;
    date: string;
    description: string;
    state: number;
    report_version: string;
}

export interface OptionType {
    value: string;
    label: string;
}

export interface Account {
    account: string;
    password: string;
    name: string;
    notes: string;
}

export interface AccountFormType extends Account {
    download: OptionType[];
    read: OptionType[];
    [key: string]: any;
}

export interface AccountType extends Account {
    download: string[];
    read: string[];
}

// Login
export async function loginUserApi(
    credentials: LoginInput
): Promise<LoginOutput> {
    const res = await axios({
        method: "POST",
        url: `${API_NEW}/admin/login`,
        data: credentials,
    });

    if (res.data.error_code === 0) {
        return res.data;
    } else {
        throw new Error(`Error during login request: ${res.data.error_desc}`);
    }
}

export async function resetPasswordApi(
    credentials: ResetPasswordInput
): Promise<SuccessedOutput> {
    const res = await axios({
        method: "POST",
        url: `${API_NEW}/me/password`,
        data: credentials,
    });
    if (res.data.error_code === 0) {
        return res.data;
    } else {
        throw new Error(
            `Error during reset password request: ${res.data.error_desc}`
        );
    }
}

//UploadFile :gcp used
// export async function UploadFilesignedurl(
//     filename: string,
//     systemType: string,
//     token: string
// ): Promise<{
//     url: string;
//     blobname: string;
//     respCode: number;
//     respDesc: string;
//     token: string;
// }> {
//     const res = await axios({
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             Authorization: `Bearer ${token}`,
//         },
//         method: "POST",
//         url: `${API_OLD}/specimen/signedurl`,
//         params: {
//             filename: filename,
//             usr_org: systemType,
//         },
//     });
//     return res.data;
// }

// export async function UploadFilesPosturl(url: string, file: FormData) {
//     // const res = await axios.post(`${url}`, file);
//     const res = await axios({
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-Type": `application/octet-stream`,
//         },
//         method: "POST",
//         url: `${API_OLD?.replace("/api", "")}${url}`,
//         data: file,
//     });
//     return res.data;
// }

// 後台上傳 ZIP 檔案
export async function uploadFileZipApi(
    file: FormData,
    token: string
): Promise<SuccessedOutput> {
    const res = await axios({
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
        },
        method: "POST",
        url: `${API_NEW}/admin/upload/zip`,
        data: file,
    });
    if (res.data.error_code === 0) {
        return res.data;
    } else {
        throw new Error("Invalid upload");
    }
}

// UploadFile: 顯示上傳紀錄
export async function getReportListAPI(
    sStartDate: string,
    sEndDate: string,
    token: string,
    systemType: string
): Promise<{
    file_list: ReportListOutput[];
    respCode: number;
    respDesc: string;
    token: string;
}> {
    const res = await axios({
        headers: {
            Authorization: `Bearer ${token}`,
        },
        method: "GET",
        url: `${API_OLD}/pmc/zip`,
        params: {
            start_time: sStartDate,
            end_time: sEndDate,
            usr_org: systemType,
        },
    });
    return res.data;
}

// 透過日期區間查詢受檢者清單及報告資料
export async function getUserListAPI(
    token: string,
    start_time: string,
    end_time: string,
    state: string | null,
    product: string,
    supplier: string,
    date_type: number = DataType.checkDate
): Promise<getUserListOutput[]> {
    const res = await axios({
        headers: {
            Authorization: `Bearer ${token}`,
        },
        method: "GET",
        url: `${API_NEW}/admin/specimen`,
        params: {
            start_time,
            end_time,
            product,
            supplier: supplier.toUpperCase(),
            state,
            date_type,
        },
    });
    if (res.data.error_code === 0) {
        return res.data.data;
    } else {
        throw new Error("Invalid response format");
    }
}

// 透過日期區間查詢受檢者清單及報告資料
export async function getAbnormalUserListAPI(
    token: string,
    start_time: string,
    end_time: string,
    state: string | null,
    product: string,
    supplier: string,
    date_type: number = DataType.checkDate
): Promise<getUserListOutput[]> {
    const res = await axios({
        headers: {
            Authorization: `Bearer ${token}`,
        },
        method: "GET",
        url: `${API_NEW}/admin/specimen/abnormal`,
        params: {
            start_time,
            end_time,
            product,
            supplier: supplier.toUpperCase(),
            state,
            date_type,
        },
    });
    if (res.data.error_code === 0) {
        return res.data.data;
    } else {
        throw new Error("Invalid response format");
    }
}

// 透過日期區間查詢受檢者清單並匯出 Excel
export async function getUserListExcelAPI(
    start_time: string,
    end_time: string,
    state: string | null,
    token: string,
    product: string,
    supplier: string,
    date_type: number = DataType.checkDate
) {
    const res = await axios({
        headers: {
            Authorization: `Bearer ${token}`,
        },
        method: "GET",
        responseType: "blob",
        url: `${API_NEW}/admin/specimen/export`,
        params: {
            start_time,
            end_time,
            product,
            supplier: supplier.toUpperCase(),
            state: state,
            date_type,
        },
    });
    if (res.status === 200) {
        return res.data;
    } else {
        throw new Error(res.data.error_desc);
    }
}

// SignListPage: 待簽名名單
export async function getSignListAPI(systemType: string): Promise<{
    user_risk_list: vSignListOutput[];
    respCode: number;
    respDesc: string;
    token: string;
}> {
    const res = await axios({
        method: "GET",
        url: `${API_OLD}/sign/user`,
        params: {
            usr_org: systemType,
        },
    });
    return res.data;
}

//Report : 顯示個人基因報告
export async function getUserReportListAPI(
    user_id: string,
    token: string
): Promise<vUserReportListOutput> {
    const res = await axios({
        headers: {
            Authorization: `Bearer ${token}`,
        },
        method: "GET",
        url: `${API_OLD}/sign/report`,
        params: {
            uid: user_id,
        },
    });
    if (res.data.respCode === 200) {
        return res.data;
    } else {
        throw new Error("Invalid response format");
    }
}

// v4 Report : 顯示個人基因報告
export async function getUserNewReportListAPI(
    uid: string
): Promise<vUserReportListOutput> {
    const res = await axios({
        method: "GET",
        url: `${API_NEW}/admin/sign/report`,
        params: {
            uid,
        },
    });
    if (res.data.error_code === 0) {
        return res.data.data;
    } else {
        throw new Error("Invalid response format");
    }
}

//UserListAddModal : 新增受試者清單
export async function uploadUserAPI(
    file: FormData,
    token: string
): Promise<vUploadFile> {
    const res = await axios.post(`${API_OLD}/specimen/uploadexcel`, file, {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
        },
    });
    return res.data;
}

//CheckExceptPage、ReportInfo、SingList : 醫師簽核or意見輸入、異常登錄
export async function DoctorSaveCommentAPI(
    systemType: string,
    data: IUserCommentInput[],
    signer?: "doctor" | "pmc"
): Promise<ResponseCode> {
    const signerQuery = signer ? `&signer=${signer}` : "";
    const res = await axios({
        headers: {
            "Content-Type": "application/json;",
        },
        method: "POST",
        url: `${API_OLD}/pmc/comment?usr_org=${systemType}${signerQuery}`,
        data: {
            user_list: data,
        },
    });
    return res.data;
}

export async function DoctorSaveAbnormalCommentAPI(
    systemType: string,
    data: IUserCommentInput[]
): Promise<Response> {
    const res = await axios({
        headers: {
            "Content-Type": "application/json;",
        },
        method: "POST",
        url: `${API_NEW}/admin/specimen/abnormal?usr_org=${systemType}`,
        data: {
            user_list: data,
        },
    });
    return res.data;
}

// 修改受檢者資料
// export async function editUserAPI(
//     vUserInfo: EditInput[],
//     token: string
// ): Promise<ResponseCode> {
//     const res = await axios({
//         headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json;",
//         },
//         method: "POST",
//         url: `${API_OLD}/spinout/modify`,
//         data: {
//             user_list: vUserInfo,
//         },
//     });
//     return res.data;
// }

// 下載PDF from url
export async function downloadReportFromUrlApi(vUserid: string, token: string) {
    const res = await axios({
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json;",
        },
        method: "GET",
        url: `${API_OLD}/specimen/pdfurl`,
        params: {
            uid: vUserid,
        },
    });

    return res.data;
}
// 後台用戶下載報告
export async function downloadPDFModeReportFromUrlApi(
    data: PostPdfMode[],
    product: string
) {
    const res = await axios({
        headers: {
            "Content-Type": "application/json;",
        },
        method: "POST",
        responseType: "blob",
        url: `${API_NEW}/admin/reports/download`,
        data: {
            data: data,
            product,
        },
    });
    if (res.data.type === "application/force-download") {
        return res;
    } else {
        const error = await res.data?.text().then((text: any) => {
            return Promise.resolve(JSON.parse(text));
        });
        throw new Error(error.error_code);
    }
}

// 下載PDF (舊的)
// export async function downloadReportApi(vUserid: string[], token: string) {
//     const res = await axios({
//         headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json;",
//         },
//         method: "POST",
//         responseType: "blob",
//         url: `${API_OLD}/specimen/pdf`,
//         data: {
//             user_list: vUserid,
//         },
//     });

//     return res.data;
// }

// 重新產pdf
// export async function redoPDFAPI(vUser: string[], token: string) {
//     const res = await axios({
//         headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json;",
//         },
//         method: "POST",
//         url: `${API_OLD}/pdf/redo`,
//         data: {
//             user_list: vUser,
//         },
//     });
//     return res.data;
// }

//拿取全部pdf mode API
// export async function getAllPdfMode(token: string): Promise<getAllPDF> {
//     const res = await axios({
//         headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json;",
//         },
//         method: "GET",
//         url: `${API_OLD}/specimen/default_pdfmod`,
//     });
//     return res.data;
// }

// 後台更新驗收日期
export async function updateAcceptanceTimeApi(
    token: string,
    userId: string,
    acp_time: string
): Promise<SuccessedOutput> {
    const res = await axios({
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json;",
        },
        method: "PUT",
        url: `${API_NEW}/admin/specimen/acceptance-time`,
        params: {
            order_no: userId,
            acp_time,
        },
    });

    if (res.data.error_code === 0) {
        return res.data;
    } else {
        throw new Error(res.data.error_desc);
    }
}
